import React, { useState } from "react";
import ExpandableSection from "../../../../components/ExpandableSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import ContractorEditModal from "./ContractorEditModal";

export default function ProjectContractors(props) {

  var {
    contractors
  } = props;

  var [showEditPopup, setShowEditPopup] = useState(false);
  var [selectedContractor, setSelectedContractor] = useState(null);

  function openEdit(contractor) {
    setSelectedContractor(contractor);
    setShowEditPopup(true);
  }

  const styles = {

    /* -------------------------------------------------
       CONTAINER & HEADER
    ------------------------------------------------- */

    container: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      overflow: "hidden",
      width: "100%"
    },

    header: {
      padding: "16px 20px",
      borderBottom: "1px solid #e6e6e6",
      background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)"
    },

    title: {
      fontSize: "18px",
      fontWeight: 600
    },

    subTitle: {
      fontSize: "12px",
      color: "#666"
    },

    /* -------------------------------------------------
       GRID HEADER
    ------------------------------------------------- */

    gridHeader: {
      display: "grid",
      gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr 1fr 0.6fr",
      padding: "10px 12px",
      fontSize: "12px",
      fontWeight: 600,
      color: "#555",
      background: "#f4f6f8",
      borderBottom: "1px solid #dfe3e8"
    },

    /* -------------------------------------------------
       ROWS
    ------------------------------------------------- */

    list: {
      flex: 1,
      overflowY: "auto"
    },

    row: {
      display: "grid",
      gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr 1fr 0.6fr",
      paddingLeft: "12px",
      alignItems: "center",
      borderBottom: "1px solid #e6e9ee",
      fontSize: "12px",
	  height:'40px'
    },

    rowAlt: {
      //background: "white"
    },

    /* -------------------------------------------------
       CELLS
    ------------------------------------------------- */

    nameCell: {
      fontWeight: 600
    },

    editCell: {
      display: "flex",
      justifyContent: "center"
    },

    editIcon: {
      color: "#1e58b6",
      cursor: "pointer",
      opacity: 0.85
    },

    /* -------------------------------------------------
       STATUS PILLS
    ------------------------------------------------- */

	pill: {
		  display:'flex',
	      padding: "4px 10px",
	      borderRadius: "7px",
	      fontSize: "12px",
		  alignItems:'center',
		  justifyContent:'space-around',
		  width:'90px'
	    },

    compliant: {
      background: "#006600",
      color: "#fff"
    },

    warning: {
      background: "#996600",
      color: "#fff"
    },

    nonCompliant: {
      background: "#990000",
      color: "#fff"
    }
  };

  return (
    <ExpandableSection
      title="Contractors"
      buttonLabel="Add Contractor"
      onButtonClick={function () {
        setShowEditPopup(true);
      }}
    >
      <div style={styles.container}>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.title}>Approved Contractors</div>
          <div style={styles.subTitle}>
            {contractors.length} contractors
          </div>
        </div>

        {/* TABLE HEADER */}
        <div style={styles.gridHeader}>
          <div>Contractor</div>
          <div>Trade</div>
          <div>Primary Contact</div>
          <div>Insurance</div>
          <div>Compliance</div>
          <div></div>
        </div>

        {/* ROWS */}
        <div style={styles.list}>
          {contractors.map(function (c, idx) {

            var complianceStyle =
              c.compliance === "Compliant"
                ? styles.compliant
                : c.compliance === "Expiring"
                ? styles.warning
                : styles.nonCompliant;

            return (
              <div
                key={c.id}
                style={{
                  ...styles.row,
                  ...(idx % 2 === 1 ? styles.rowAlt : {})
                }}
              >
                <div style={styles.nameCell}>{c.name}</div>
                <div>{c.trade}</div>
                <div>{c.contact}</div>

                <div style={{paddingRight:'10px'}}>
                  <span
                    style={{
                      ...styles.pill,
                      ...(c.insuranceValid
                        ? styles.compliant
                        : styles.nonCompliant)
                    }}
                  >
                    {c.insuranceValid ? "Valid" : "Expired"}
                  </span>
                </div>

                <div>
                  <span
                    style={{
                      ...styles.pill,
                      ...complianceStyle
                    }}
                  >
                    {c.compliance}
                  </span>
                </div>

                <div style={styles.editCell}>
                  <FontAwesomeIcon
                    icon={faPen}
                    style={styles.editIcon}
                    onClick={function () {
                      openEdit(c);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>

      </div>
		
      {/* ContractorEditModal goes here */}
	  <ContractorEditModal
	      open={showEditPopup}
	      onClose={function () { setShowEditPopup(false); }}
	    />
    </ExpandableSection>
  );
}
